import { useEnabledFeatures } from '~/common/hooks/enabled-features';
import { useDexDeviceIdentificationErrorState } from './use-show-dex-device-identification-error';

/**
 * Determines whether the current user is allowed to access DEX (Data Exchange) features.
 *
 * Access is granted only when all required prerequisites are satisfied:
 * - The `dataExchange` feature flag is enabled
 * - Device-identification access checks are not still in progress
 * - No device-identification errors are present
 *
 * @returns {{
 *   isDexEnabled: boolean;
 *   isLoading: boolean;
 * }}
 */
export function useIsDexEnabled(): {
    isDexEnabled: boolean;
    isLoading: boolean;
} {
    const { dataExchange } = useEnabledFeatures();
    const { isCheckingDeviceIdentification, showDexDeviceIdentificationError } =
        useDexDeviceIdentificationErrorState();

    const isDexEnabled =
        !!dataExchange && !isCheckingDeviceIdentification && !showDexDeviceIdentificationError;

    return { isDexEnabled, isLoading: isCheckingDeviceIdentification };
}
